// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/audit_search.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TaskView } from "./task";
import { TaskAuditView } from "./audit";
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchRequest
 */
export interface TaskAuditSearchServiceSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The list of user IDs who are involved in the audit events.
     *
     * @generated from protobuf field: repeated string user_ids = 3
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWithTask
 */
export interface TaskAuditWithTask {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAuditView audit = 1
     */
    audit?: TaskAuditView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 2
     */
    task?: TaskView;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchResponse
 */
export interface TaskAuditSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskAuditWithTask list = 1
     */
    list: TaskAuditWithTask[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSearchServiceSearchRequest$Type extends MessageType<TaskAuditSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.task.v1.TaskAuditSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskAuditSearchServiceSearchRequest>): TaskAuditSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<TaskAuditSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditSearchServiceSearchRequest): TaskAuditSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string user_ids */ 3:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string user_ids = 3; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchRequest
 */
export const TaskAuditSearchServiceSearchRequest = new TaskAuditSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWithTask$Type extends MessageType<TaskAuditWithTask> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWithTask", [
            { no: 1, name: "audit", kind: "message", T: () => TaskAuditView },
            { no: 2, name: "task", kind: "message", T: () => TaskView }
        ]);
    }
    create(value?: PartialMessage<TaskAuditWithTask>): TaskAuditWithTask {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskAuditWithTask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditWithTask): TaskAuditWithTask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskAuditView audit */ 1:
                    message.audit = TaskAuditView.internalBinaryRead(reader, reader.uint32(), options, message.audit);
                    break;
                case /* c1.api.task.v1.TaskView task */ 2:
                    message.task = TaskView.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditWithTask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskAuditView audit = 1; */
        if (message.audit)
            TaskAuditView.internalBinaryWrite(message.audit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskView task = 2; */
        if (message.task)
            TaskView.internalBinaryWrite(message.task, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWithTask
 */
export const TaskAuditWithTask = new TaskAuditWithTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSearchServiceSearchResponse$Type extends MessageType<TaskAuditSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.task.v1.TaskAuditSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskAuditWithTask },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskAuditSearchServiceSearchResponse>): TaskAuditSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskAuditSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskAuditSearchServiceSearchResponse): TaskAuditSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskAuditWithTask list */ 1:
                    message.list.push(TaskAuditWithTask.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskAuditSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskAuditWithTask list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskAuditWithTask.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchResponse
 */
export const TaskAuditSearchServiceSearchResponse = new TaskAuditSearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskAuditSearchService
 */
export const TaskAuditSearchService = new ServiceType("c1.api.task.v1.TaskAuditSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: TaskAuditSearchServiceSearchRequest, O: TaskAuditSearchServiceSearchResponse }
]);
